import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-1.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-primary-foreground/30 bg-primary text-primary-foreground",
        secondary:
          "border-secondary-foreground/30 bg-secondary text-secondary-foreground",
        destructive:
          "border-destructive-foreground/30 bg-destructive text-destructive-foreground",
        outline: "border-foreground/30 text-foreground",
        success:
          "border-status-green-text/30 bg-status-green-bg text-status-green-text",
        danger:
          "border-status-red-text/30 bg-status-red-bg text-status-red-text",
        warning:
          "border-status-amber-text/30 bg-status-amber-bg text-status-amber-text",
        info:
          "border-status-blue-text/30 bg-status-blue-bg text-status-blue-text",
        role:
          "border-status-plum-text/30 bg-status-plum-bg text-status-plum-text",
        neutral:
          "border-ink-secondary/30 bg-paper-muted text-ink-secondary",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
